import{a as r}from"./chunk-LKOWEUPS.js";import{a as n}from"./chunk-RAAYCPUM.js";function i(...o){return n(r(Math.round),o)}export{i as a};
